import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import { loginUser } from "../../../_actions/user_actions";
import { useDispatch } from "react-redux";
import { authService } from "../LoginPage/FirebaseServiceAccount";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import styled from 'styled-components';

const ImgBack = styled.img`
    position: absolute;
    width: 8.75px;
    height: 16px;
    left: 24px;
    top: 24px;
`;

const DivText1 = styled.div`
    position: absolute;
    right: 16px;
    height: 22px;
    left: 16px;
    top: 92px;

    /* 1 */
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    /* identical to box height, or 122% */

    letter-spacing: -0.02em;

    /* Default/Gray/700 */

    color: #333333;
`;

const DivText2 = styled.div`
    position: absolute;
    right: 16px;
    height: 56px;
    left: 16px;
    top: 122px;

    /* 2 */

    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    /* or 117% */

    letter-spacing: -0.02em;

    /* Default/Gray/700 */

    color: #333333;

`;

const BtnJoin = styled.button`
    position: absolute;
    right: 16px;
    height: 48px;
    left: 16px;
    top: 226px;

    background: #3A7AF2;
    border-radius: 24px;
    color: #fff;
    border: none;
`;

const BtnGoogleLogin = styled(BtnJoin)`
    top: 290px;
`;

const DivText3 = styled.div`
    position: absolute;
    height: 36px;
    left: 67px;
    right: 67px;
    top: 354px;

    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    /* or 150% */

    text-align: center;
    letter-spacing: -0.02em;

    /* Black */

    color: #000000;
`;

const DivText4 = styled.div`
    position: absolute;
    height: 20px;
    left: 104px;
    right: 104px;
    top: 574px;

    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    /* identical to box height, or 125% */

    text-align: center;
    letter-spacing: -0.02em;

    color: #333333;
`;

const BtnLogin = styled.button`
    box-sizing: border-box;

    /* Auto layout */

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 16px;
    gap: 10px;

    position: absolute;
    right: 16px;
    height: 46px;
    left: 16px;
    top: 614px;

    border: 1px solid #EBEBEB;
    border-radius: 48px;

    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    /* identical to box height, or 122% */

    text-align: center;
    letter-spacing: -0.02em;

    color: #fff;
`;


function JoinPage1(props) {
    const dispatch = useDispatch();

    function requestLogin(email, password, name) {
        let dataToSubmit = {
            email,
            password,
            fcmregtk: localStorage.getItem('fcmregtk')
        };

        dispatch(loginUser(dataToSubmit))
            .then(response => {
                if (response.payload.loginSuccess) {
                    props.history.push("/");
                } else if (response.payload.errCode == 2) {
                    alert(response.payload.message + ":" + email + ":" + password);
                } else {
                    console.log('회원가입으로 이동');
                    props.history.push({
                        pathname: "/join2",
                        state: { email, password, name }
                    });
                }
            });
    }

    const onClickGoogleLogin = e => {
        console.log('onClickGoogleLogin');

        if (window?.Android) {
            console.log('request Android SignIn');
            window.Android.getSignIn('requestSignIn');
        }
        else {
            const email_droid = localStorage.getItem('email_droid');
            const uid_droid = localStorage.getItem('uid_droid');
            const name_droid = localStorage.getItem('name_droid');
            if (email_droid && uid_droid && name_droid) {
                requestLogin(email_droid, email_droid, name_droid);
            }
            else {
                signInWithPopup(authService, new GoogleAuthProvider())
                    .then((result) => {
                        const user = result.user;
                        requestLogin(user.email, user.email, user.displayName);
                    })
                    .catch((error) => {
                        console.log('Google Sign-In Error:', error);
                        alert('Google 로그인 중 오류가 발생했습니다: ' + error.message);
                    });
            }

        }

    };


    useEffect(() => {

        window.signInCallback = (email, password, name) => {
            console.log('signInCallback()');
            requestLogin(email, email, name);
        };

    }, []);


    return (
        <div >
            <ImgBack src="/images/arrow-back.png" alt="back" onClick={() => props.history.goBack()} />

            <DivText1>프로젝트허브 시작하기</DivText1>
            <DivText2>무한한 해커톤이 열리는<br />
                공간에 오신 것을 환영합니다.</DivText2>

            <Link to='/join2'>
                <BtnJoin >이메일로 회원가입</BtnJoin>
            </Link>
            <BtnGoogleLogin onClick={onClickGoogleLogin}>구글 계정으로 시작하기</BtnGoogleLogin>

            <DivText3>프로젝트허브에 가입하면 프로젝트허브의 이용 약관과<br />
                개인정보 취급방침에 동의하게 됩니다</DivText3>

            <DivText4>이미 계정이 있으신가요?</DivText4>

            <BtnLogin>
                로그인
            </BtnLogin>
        </div>
    );
};

export default withRouter(JoinPage1);


